import { FC } from 'react'
import { useWindowSize } from 'react-use'
import {
    getStyledImageHolder
} from '../../styled-components/HomeSection.styled'
import { MD_SCREEN } from '../../util/screen-size'
import { BrandsContainer } from './BrandsContainer.component'
import { DealsSection } from './DealsSection.component'
import { HeroSection } from './HeroSection.component'
import { MobileActions } from './MobileActions.component'
const heroImage = require('../../util/images/heroimage.png')

export interface HomeContentProps {

}

export const HomeContent: FC<HomeContentProps> = (props) => {

    const { width } = useWindowSize();
    const size = width > MD_SCREEN


    const renderMobileItems = () => {
        if (!size)
            return (
                <>
                    <div className="overlay" />
                    <MobileActions />
                </>
            )
    }

    const StyledImageHolder = getStyledImageHolder()

    return (
        <>
            <StyledImageHolder>
                <img src={heroImage} alt="hero" />
                {renderMobileItems()}
                <HeroSection />
            </StyledImageHolder>
            <BrandsContainer />
            <DealsSection />
        </>
    )
}